/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import { toast } from "react-toastify";
import { enableStatus, listAddonData } from "../core/_requests";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../../component/Pagination";
import SearchInput from "../../../component/core/Searchinput";
import { Placeholder } from "react-bootstrap";
import Addbutton from "../../../component/core/Addbuttons";
interface Addon {
  chefId: string | undefined;
  name: string;
  primaryId: string;
  amount: number;
  type: {
    iconUrl: string;
    name: string;
  };
  enableDisableStatus: boolean;
  createdBy: string;
  updatedBy: string;
}

const ListAddons = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [listType, setListType] = useState<Addon[]>([]);
  const [search, setSearch] = useState("");
  const chefId = currentUser?.uuid;

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dataSearch = searchParams.get("search");
  // useEffect to set the search term from URL (or local storage if needed)
  useEffect(() => {
 
    if (dataSearch !== null) {
      setSearch(dataSearch);
    }
  }, [dataSearch]);
  const filterData = {
    search: dataSearch,
  };

 
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await listAddonData(chefId, filterData);
        setListType(res?.data || []);
      } catch (error) {
        console.error("Error fetching addons:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [chefId]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const clickApply = async () => {
    setLoading(true);
    const data = { search };
    try {
      const res = await listAddonData(chefId, data);
      setListType(res?.data || []);
    } catch (error) {
      console.error("Error fetching addons:", error);
    } finally {
      setLoading(false);
    }
  };

  const editAddon = (primaryId: string) => {
    navigate("/addons/edit/" + primaryId);
  };

  const deleteAddon = (primaryId: string) => {
    navigate("/addons/delete/" + primaryId);
  };

  const handleEnableDisable = async (id: string, status: boolean) => {
    const enableDisable = !status; // Toggle the status
    const data = { enableDisableStatus: enableDisable };

    try {
      const res = await enableStatus(id, data);
      toast.success(res?.message, { autoClose: 5000 });
      const updatedRes = await listAddonData(chefId, filterData);
      setListType(updatedRes?.data || []);
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = listType.slice(indexOfFirstItem, indexOfLastItem);
  const pages = Math.ceil(listType.length / itemsPerPage);

  const pageNumbers = Array.from({ length: pages }, (_, i) => i + 1);

  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            <section className="row main-content">
              <Addbutton
                title="Addons"
                count={listType.length}
                searchValue={search}
                onSearchChange={handleSearchChange}
                onSearchKeyUp={clickApply}
                buttonText="Add Addon"
                buttonIcon="add_circle"
                onButtonClick={() => navigate("/addons/add")}

              />


              <div className="table-wrap mt-4">
                <table className="table custom-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Amount ($)</th>
                      <th>Type</th>
                      <th>Available</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={6} className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : currentItems.length > 0 ? (
                      currentItems.map((item, i) => (
                        <tr key={item.primaryId}>
                          <td>{indexOfFirstItem + i + 1}</td>
                          <td>
                            <p className="mb-0">{item.name}</p>
                          </td>
                          <td>
                            <p className="mb-0">{item.amount.toFixed(2)}</p>
                          </td>
                          <td>
                            <p className="mb-0 type">
                              <img src={item.type.iconUrl} alt="Type" />{" "}
                              {item.type.name}
                            </p>
                          </td>
                          <td>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input cursorPointer"
                                type="checkbox"
                                checked={item.enableDisableStatus}
                                onChange={() =>
                                  handleEnableDisable(
                                    item.primaryId,
                                    item.enableDisableStatus
                                  )
                                }
                              />
                              <label className="yes">Yes</label>
                              <label className="no">No</label>
                            </div>
                          </td>
                          <td>
                            <div className="action-item">
                              <a onClick={() => editAddon(item.primaryId)}>
                                <span className="material-symbols-outlined">
                                  edit
                                </span>
                              </a>
                              <a
                                className="danger cursorPointer"
                                onClick={() => deleteAddon(item?.primaryId)}
                              >
                                <span className="material-symbols-outlined">
                                  delete
                                </span>
                              </a>

                            </div>

                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">
                           No Addons Added – Start Creating Some!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <Pagination
                data={listType}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                currentItems={currentItems}
                pages={pages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageNumbers={pageNumbers}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
              />
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default ListAddons;
